<div class="accordion-container">
  @for (accordion of accordions(); track accordion; let i = $index) {
    <div class="toggle-container">
      <div (click)="toggleAccordion(i)" class="toggle-header">
        <span>{{accordion.classCode}} - {{accordion.className}}</span>
        <lib-icon [icon]="activeIndex === i ? 'angle-up' : 'angle-down'" class="icon"></lib-icon>
      </div>
      @if (activeIndex === i) {
        <p class="large py-5">{{accordion.classDescription}}</p>
        <div [innerHTML]="accordion.eligibleStatement"></div>
        <div class="pt-5" [innerHTML]="accordion.ineligibleStatement"></div>
      }
    </div>
  }
</div>